import React from 'react'

const WebsiteIdContext = React.createContext(null)
WebsiteIdContext.displayName = 'WebsiteIdContext'

export default WebsiteIdContext
